<template>
  <AnalyticsTemplate 
    page-title="桥梁偏航统计"
    chart-type="deviation"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'DeviationAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
